export enum PlayerType {
    Default = 0,
    First,
    Second,
    Third,
    Fourth,
    Fifth,
    Sixth,
    Seventh,
    Eighth,
    Nine,
    Neutral
}
